import axios from "axios";
import { getMetaDataFetchPayload } from "./globalActionUtils";
import { getUrl } from "./urls";
import { getAccessToken, getCompanyId, getUserId } from "./utils.js";
import { toast } from "react-toastify";
import { sortOptionChange } from "./refineFilterAction";
import { dispatch } from "d3";

export const SET_NOTIFICATIONS_LIST = "SET_NOTIFICATIONS_LIST";
export const CHART_REMOVED = "CHART_REMOVED";

export const SET_IMAGE_URL = "SET_IMAGE_URL";
export const SET_DATA_USAGE_HISTORY = "SET_DATA_USAGE_HISTORY";
export const SET_DATA_USAGE = "SET_DATA_USAGE";
export const SET_DATA_USAGE_COUNTRYWISE = "SET_DATA_USAGE_COUNTRYWISE";
export const SET_DATA_WORD_CLOUD = "SET_DATA_WORD_CLOUD";
export const SET_COMPANY_USERS = "SET_COMPANY_USERS";
export const SET_COMPANY_TEAMS = "SET_COMPANY_TEAMS";
export const FETCH_META_DATA = "FETCH_META_DATA";
export const FETCH_META_DATA_QUERYPARAM = "FETCH_META_DATA_QUERYPARAM";
export const FETCH_PUBLIC_META_DATA = "FETCH_PUBLIC_META_DATA";

export const GET_NOTIFICATION_COUNTER = "GET_NOTIFICATION_COUNTER";
export const PACKAGE_UPGRADE_POPUP = "PACKAGE_UPGRADE_POPUP";

export const SHOW_CONTACT_US = "SHOW_CONTACT_US";
export const SHOW_CONTACT_US_LOADER = "SHOW_CONTACT_US_LOADER";
export const TOGGLE_VIRALITY_MODE = "TOGGLE_VIRALITY_MODE";
export const SIDEBAR_TOGGLE = "SIDEBAR_TOGGLE";
export const SWITCH_ACCOUNT_DETAILS = "SWITCH_ACCOUNT_DETAILS";
export const CREATE_FIRST_QUERY = "CREATE_FIRST_QUERY";
export const TOGGLE_TRANSLATE = "TOGGLE_TRANSLATE";
export const CHANGE_TRANSLATE = "CHANGE_TRANSLATE";
export const SET_PUBLIC_ACCESS_TOKEN = "SET_PUBLIC_ACCESS_TOKEN";
export const SHOW_CONFIGURE_POST = "SHOW_CONFIGURE_POST";
export const IS_SWITCH_COMPANY_PRESENT = "IS_SWITCH_COMPANY_PRESENT";
export const TOGGLE_GET_STARTED = "TOGGLE_GET_STARTED";
export const HIDE_GETTING_STARTED = "HIDE_GETTING_STARTED";
export const GET_PROGRESS = "GET_PROGRESS";
export const CONFIGURE_PROGRESS = "CONFIGURE_PROGRESS";
export const ROUTING_PAGE = "ROUTING_PAGE";
export const COMPANY_DETAILS = "COMPANY_DETAILS";
export const GET_NOTIFICATION_COUNTER_CLEAR = "GET_NOTIFICATION_COUNTER_CLEAR";
export const NOTIFICATION_COUNTER_EVENTS = "NOTIFICATION_COUNTER_EVENTS";
// ----------Updating Filters------------
export const STEPS_COMPLETED = "STEPS_COMPLETED";

export function toggleViralityMode() {
    return {
        type: TOGGLE_VIRALITY_MODE,
        payload: "",
    };
}

// --------Toggles-----------

// -----------MetaData----------------
export const fetchMetaData = (queryParam) => {
    let payload = getMetaDataFetchPayload(queryParam);
    return function (dispatch) {
        payload.then((data) => {
            if (data.company.company_identifier === "sk2pg") {
                dispatch(sortOptionChange("impact_value"));
            }
            dispatch(getNotificationCounter());
        });
        if (queryParam) {
            return dispatch({
                type: FETCH_META_DATA_QUERYPARAM,
                payload,
            });
        } else {
            return dispatch({
                type: FETCH_META_DATA,
                payload,
            });
        }
    };
};

export function fetchPublicMetaData(queryParam) {
    // console.log("callllled");
    let isPublic = true;
    let payload = getMetaDataFetchPayload(queryParam, isPublic);

    return {
        type: FETCH_PUBLIC_META_DATA,
        payload,
    };
}

export function getNotificationCounter() {
    return function (dispatch) {
        axios
            .get(`${getUrl("notif_counter")}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: GET_NOTIFICATION_COUNTER,
                    payload: response.data?.data,
                });
            })
            .catch((error) => {
                console.log(error);
                console.log("error", error?.response?.data?.message);
                toast.error("Oops! We encountered an error. Please refresh the page and retry logging in.");
            });
    };
}

export function getNotificationCounterClear() {
    return function (dispatch) {
        axios
            .post(`${getUrl("notif_counter_clear")}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "GET_NOTIFICATION_COUNTER_CLEAR",
                    payload: response.data,
                });
            })
            .catch((error) => {
                console.log(error);
                toast.error("Oops! We encountered an error. Please refresh the page and retry logging in.");
            });
    };
}

export function gettingStartedProgress() {
    return function (dispatch) {
        axios
            .get(`${getUrl("get_progress")}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: GET_PROGRESS,
                    payload: response?.data?.data,
                });
            })
            .catch((error) => {
                console.log(error);
                toast.error("Error in retaining your progress on the platform");
            });
    };
}

export function configure_progress(field_name, total_sections) {
    let body = {
        total_sections: total_sections,
        progress_config: {},
    };
    if (field_name == "explore_search") {
        body = {
            total_sections: total_sections,
            progress_config: {
                explore_search: 1,
            },
        };
    }
    if (field_name == "explore_dashboards") {
        body = {
            total_sections: total_sections,
            progress_config: {
                explore_dashboards: 1,
            },
        };
    }
    if (field_name == "whats_trending") {
        body = {
            total_sections: total_sections,
            progress_config: {
                whats_trending: 1,
            },
        };
    }
    // if (field_name == "owned_page_analytics") {
    //     body = {
    //         total_sections: total_sections,
    //         progress_config: {
    //             owned_page_analytics: 1,
    //         },
    //     };
    // }
    // if (field_name == "social_media_response") {
    //     body = {
    //         total_sections: total_sections,
    //         progress_config: {
    //             social_media_response: 1,
    //         },
    //     };
    // }
    if (field_name == "manage_users") {
        body = {
            total_sections: total_sections,
            progress_config: {
                manage_users: 1,
            },
        };
    }
    if (field_name == "update_profile") {
        body = {
            total_sections: total_sections,
            progress_config: {
                update_profile: 1,
            },
        };
    }

    return function (dispatch) {
        axios
            .post(getUrl("configure_progress"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                dispatch(gettingStartedProgress());
                return {
                    type: CONFIGURE_PROGRESS,
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };
}
export function configure_getting_started_progress(body) {
    return function (dispatch) {
        axios
            .post(getUrl("configure_progress"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                dispatch(gettingStartedProgress());
                return {
                    type: CONFIGURE_PROGRESS,
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

export function UpdateUserDetails(body, position, showMsg = true) {
    return function (dispatch) {
        axios
            .patch(getUrl("update_user_details"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                dispatch(fetchMetaData("company"));
                if (showMsg)
                    if (position == "navbar") {
                        if (body.interactive_help_enabled == 1) toast.success("Interactive Help is enabled");
                        if (body.interactive_help_enabled == 0) toast.success("Interactive Help is disabled");
                    } else toast.success("Updated Successfully");
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
    };
}

export function profileSetup(body) {
    return async function (dispatch) {
        return axios
            .post(getUrl("profile_setup"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                dispatch(fetchMetaData("company"));
                // toast.success("Congratulations! You can now start using the platform.");
                return response;
            })
            .catch((error) => {
                toast.error(error.response?.data?.message ? error.response?.data?.message : "Failed to update. Please try again.");
            });
    };
}

export function getIndustries() {
    return async function () {
        return axios
            .get(getUrl("get_industries"), {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "access-token": getAccessToken(),
                },
            })
            .then((response) => {
                return response.data.data.industries;
            })
            .catch((error) => {
                console.error(error);
            });
    };
}

export function UpdateCompanyDetails(body) {
    return async (dispatch) => {
        let res = await axios
            .patch(getUrl("update_company_details"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                return dispatch(fetchMetaData("company"));
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });

        return res;
    };
}

export const switchAccountDetails = (id) => {
    let data = {
        company_id: id,
    };
    return function (dispatch) {
        axios
            .post(`${getUrl("switch_account")}/?access-token=${getAccessToken()}`, data, {
                headers: {
                    "Content-type": "application/json; charset=utf-8",
                },
            })
            .then((res) => {
                // console.log("res..account", res);
                localStorage.setItem("accessToken", res.data.data.accessToken);
                dispatch({
                    type: SWITCH_ACCOUNT_DETAILS,
                    payload: res.data.data.accessToken,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

export function UploadPhoto(imageFile) {
    const formData = new FormData();
    formData.append("title", "image");
    formData.append("image", imageFile);
    return function (dispatch) {
        axios
            .post(getUrl("upload_photo"), formData, {
                headers: {
                    "Content-type": "multipart/form-data",
                },
            })
            .then((response) => {
                //dispatch(fetchMetaData('company'));
                dispatch({
                    type: SET_IMAGE_URL,
                    payload: response.data.data,
                });
                toast.success("Photo uploaded successfully");
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function GetDataUsageHistoric(body) {
    return function (dispatch) {
        axios
            .post(getUrl("get_data_usage_historic"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                //dispatch(fetchMetaData('company'));
                dispatch({
                    type: SET_DATA_USAGE_HISTORY,
                    payload: response.data.total_records_tagged,
                });
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function GetDataUsage(body) {
    return function (dispatch) {
        axios
            .post(getUrl("get_data_usage"), body, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: SET_DATA_USAGE,
                    payload: response.data,
                });
            })
            .catch((error) => {
                if (error.response && error.response.body && error.response.body.message) toast.error(error.response.body.message);
                else toast.error("Some error occured");
            });
    };
}

export function GetDataCountryWise(body) {
    return function (dispatch) {
        axios
            .post(getUrl("get_data_countrywise"), body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch({
                    type: SET_DATA_USAGE_COUNTRYWISE,
                    payload: response.data,
                });
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

// export function GetNotificationList(offset) {
//     let res = axios({
//         method: "post",
//         url: `${getUrl("get_notifications_list")}&limit=50&offset=${offset}`,
//         headers: {
//             "Content-Type": "application/json",
//             cache: false,
//             "access-token": getAccessToken(),
//         },
//         data,
//     })
//         .then((res) => {
//             return res.data.data.notifications;
//         })
//         .catch((err) => {
//             toast.error(err.response.data.message);
//             return err;
//         });

//     return {
//         type: "SET_NOTIFICATIONS_LIST",
//         payload: res,
//     };
// }

export function GetNotificationList(offset) {
    return function (dispatch) {
        axios
            .get(`${getUrl("get_notifications_list")}&limit=50&offset=${offset}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch({
                    type: SET_NOTIFICATIONS_LIST,
                    payload: response.data.data.notifications || [],
                });
            })
            .catch((error) => {
                toast.error(error.response.data.message);
                throw error;
            });
    };
}

export function getWordCloudData() {
    return function (dispatch) {
        axios
            .get(`${getUrl("get_word_cloud_data")}&companyId=${getCompanyId()}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch({
                    type: SET_DATA_WORD_CLOUD,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

// export const handleToggleNotificationSound = () => {
//     return {
//         type: "TOGGLE_NOTIFICATION_SOUND",
//     };
// };

export function SendNotificationSettings(body, value) {
    let payLoad = body.param;
    return function (dispatch) {
        axios
            .patch(`${getUrl("set_notification_settings")}/${getUserId()}?access-token=${getAccessToken()}`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (response.data.status === "success") {
                    if (payLoad.notification_alert?.smr_ticket_assigned?.web?.is_enabled !== undefined) {
                        const successMessage = payLoad.notification_alert.smr_ticket_assigned.web.is_enabled ? "Enabled successfully" : "Disabled successfully";

                        toast.success(successMessage);
                    }
                    if (payLoad.notification_alert?.notification_sound?.web?.is_enabled !== undefined) {
                        const soundSuccessMessage = payLoad.notification_alert.notification_sound.web.is_enabled
                            ? "Notification sound enabled successfully"
                            : "Notification sound disabled successfully";

                        toast.success(soundSuccessMessage);
                    }
                    dispatch(fetchMetaData());
                } else {
                    toast.error(response.data.status);
                }
            })
            .catch((error) => {
                console.log("error", error);
                toast.error(error.response.body?.message);
            });
    };
}

export function deleteWordCloudItem(body) {
    return function (dispatch) {
        return axios
            .delete(getUrl("delete_word_cloud_item"), {
                headers: {
                    "Content-Type": "application/json",
                },
                data: body,
            })
            .then((response) => {
                // dispatch(getWordCloudData());
                // toast.success("Deleted Successfully");
                return response;
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function GetCompanyUsers(userType) {
    userType = userType === "all" ? "user,admin,companyadmin" : userType;
    return function (dispatch) {
        axios
            .get(`${getUrl("get_company_users")}/${getCompanyId()}/users?access-token=${getAccessToken()}&userTypes=${userType}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch({
                    type: SET_COMPANY_USERS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function CreateUser(body) {
    return function (dispatch) {
        return axios
            .post(`${getUrl("create_user")}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                console.log(response.data);
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.data?.message) {
                    toast.error(error.response.data.message);
                } else toast.error("Something went wrong.");
                return error.response.data;
            });
    };
}

export function UpdateUserManagement(body, id) {
    return function (dispatch) {
        axios
            .patch(`${getUrl("update_user_management")}/${id}?access-token=${getAccessToken()}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch(GetCompanyUsers("all"));
                toast.success("User details updated successfully");
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function GetCompanyTeams() {
    return function (dispatch) {
        axios
            .get(`${getUrl("get_company_teams")}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch({
                    type: SET_COMPANY_TEAMS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function MarkAsRead(body, id, count, mssg, offset) {
    return function (dispatch) {
        axios
            .patch(`${getUrl("mark_as_read")}/web/${id}?access-token=${getAccessToken()}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (count === 1) {
                    if (response.data.status === "success") {
                        dispatch(GetNotificationList(0));
                        dispatch(getNotificationCounter());
                        toast.success(`${mssg} Successfully`);
                    } else {
                        toast.error(response.data.status);
                    }
                }
            })
            .catch((error) => {
                return toast.error(error.message);
            });
    };
}

export function CreateTeam(body) {
    return function (dispatch) {
        axios
            .post(`${getUrl("create_team")}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch(GetCompanyTeams());
                toast.success("Created a team successfully");
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function DeleteNotification(id, count, offset) {
    return function (dispatch) {
        axios
            .delete(`${getUrl("mark_as_read")}/${id}?access-token=${getAccessToken()}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (count === 1) {
                    if (response.data.status === "success") {
                        //dispatch(GetNotificationList(0));
                        dispatch(getNotificationCounter());
                        toast.success("Deleted Successfully");
                        location.reload();
                    } else {
                        toast.error(response.data.status);
                    }
                }
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}
export function UpdateTeam(body, id) {
    return function (dispatch) {
        axios
            .patch(`${getUrl("update_team")}/${id}?access-token=${getAccessToken()}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                dispatch(GetCompanyTeams());
                toast.success("Team details have been updated successfully");
            })
            .catch((error) => {
                toast.error(error.response.body.message);
            });
    };
}

export function showContactUsPopup(val) {
    return function (dispatch) {
        dispatch({ type: SHOW_CONTACT_US, payload: val });
    };
}

export function ContactUs(data) {
    var formData = new FormData();
    formData.append("name", data.name);
    formData.append("company", data.company);
    formData.append("email", data.email);
    formData.append("contact", data.contact);
    formData.append("description", data.msg);
    return function (dispatch) {
        dispatch({ type: SHOW_CONTACT_US_LOADER, payload: true });
        let api_url = "https://20twenty.circussocial.com/site/api?mode=post&uri=Contact&access-token=" + getAccessToken();
        axios
            .post(api_url, formData, {
                cache: false,
                headers: {
                    "Content-Type": "application/text; charset=UTF-8",
                },
            })
            .then((response) => {
                console.log(response);
                if (response.statusText == "OK") {
                    dispatch({ type: SHOW_CONTACT_US, payload: false });
                    dispatch({ type: SHOW_CONTACT_US_LOADER, payload: false });
                    toast.success("Thank you for contacting us. We will get back to you soon.");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

export const sidebarToggle = (payload) => {
    return {
        type: SIDEBAR_TOGGLE,
        payload,
    };
};

export const hideGettingStarted = () => {
    axios
        .post(
            `${getUrl("hide_getting_started")}`,
            {
                total_sections: 11,
                progress_config: {
                    hide_getting_started: 1,
                },
            },
            {
                headers: {
                    "Content-type": "application/json; charset=utf-8",
                },
            },
        )
        .then((res) => {
            dispatch(gettingStartedProgress());
            return {
                type: HIDE_GETTING_STARTED,
            };
        })
        .catch((err) => {
            console.log(err);
        });
};

export const createFirstQuery = (boolVal) => {
    return {
        type: CREATE_FIRST_QUERY,
        payload: boolVal,
    };
};

export const stepsCompleted = (stepName) => {
    return {
        type: STEPS_COMPLETED,
        payload: stepName,
    };
};
export const toggleGoogleTranslate = () => {
    return {
        type: TOGGLE_TRANSLATE,
    };
};

export const changeGoogleTranslateLanguage = (lang) => {
    sessionStorage.setItem("selectedLanguage", lang);
    return {
        type: CHANGE_TRANSLATE,
        payload: lang,
    };
};

export const packageUpgradePopup = (payload) => {
    return {
        type: PACKAGE_UPGRADE_POPUP,
        payload,
    };
};

export const setPublicAccessToken = (payload) => {
    return {
        type: SET_PUBLIC_ACCESS_TOKEN,
        payload,
    };
};

export function showConfigureFbPost(bool) {
    //show fb comments modal
    return {
        payload: bool,
        type: SHOW_CONFIGURE_POST,
    };
}

export function toggleGetStarted(payload) {
    return {
        type: TOGGLE_GET_STARTED,
        payload,
    };
}

export function isSwitchCompanyAvailable(bool) {
    //show fb comments modal
    return {
        payload: bool,
        type: IS_SWITCH_COMPANY_PRESENT,
    };
}

export function updateRouteValues(val) {
    return {
        type: ROUTING_PAGE,
        payload: val,
    };
}
export function getCompanyDetails() {
    const response = axios
        .get(`${getUrl("twostep_verification")}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data?.company;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });
    return {
        type: "COMPANY_DETAILS",
        payload: response,
    };
}

export function sseTrigger(data) {
    return {
        type: "SSE_EVENTS",
        payload: data,
    };
}

export function sseTicketId(data) {
    return {
        type: "SSE_TICKET_EVENTS",
        payload: data,
    };
}
export function notificationCounter(data) {
    return {
        type: "NOTIFICATION_COUNTER_EVENTS",
        payload: data,
    };
}

export function changeGoogleCLientId(id) {
    return {
        type: "CHANGE_GOOGLE_CLIENT_ID",
        payload: id,
    };
}
